import React from 'react';
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {DateCell, LinkCell} from "../../components/common/advance-table/CustomCells";
import AdvanceTableWrapper from "../../components/common/advance-table/AdvanceTableWrapper";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../components/common/advance-table/AdvanceTablePagination";

const cols = [
    {
        accessor: 'name',
        Header: 'Name',
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const {name, id} = rowData.row.original;
            return <LinkCell name={name} to={"/contracts/" + id} />;
        }
    },
    {
        accessor: 'network.name',
        Header: 'Network',
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const {network} = rowData.row.original;
            return <LinkCell name={network.name} to={"/networks/" + network.id} />;
        }
    },
    {
        accessor: 'startDate',
        Header: 'Start Date',
        Cell: DateCell
    },
    {
        accessor: 'endDate',
        Header: 'End Date',
        Cell: DateCell
    }
];

const OrganizationContracts = ({contracts}) => {
    const data = useFragment(graphql`
        fragment OrganizationContracts_Contracts on LegalContract @relay(plural: true) {
            id
            name
            startDate
            endDate
            network {
                id
                name
            }
        }
    `, contracts);

    return (
        <AdvanceTableWrapper columns={cols}
                             data={data}
                             sortable
                             pagination
                             perPage={10}
        >
            <Card className={"mb-3"}>
                <Card.Header>
                    <CardTableHeader title={"Contracts"}
                                     showNew={false}
                                     onNewClick={() => {}}
                    />
                </Card.Header>
                <Card.Body className={"p-0"}>
                    <AdvanceTable table
                                  headerClassName="bg-200 text-900 text-nowrap align-middle"
                                  rowClassName="align-middle white-space-nowrap"
                                  tableProps={{
                                      size: 'sm',
                                      striped: true,
                                      className: 'fs--1 mb-0 overflow-hidden'
                                  }}
                    />
                </Card.Body>
                <Card.Footer>
                    <AdvanceTablePagination table/>
                </Card.Footer>
            </Card>
        </AdvanceTableWrapper>
    );
};

export default OrganizationContracts;